import { useBreakpoint, useVerticalBreakpoint } from '@sparx/sparx-design/hooks';

export const useIsFixedWidthContainer = () => {
  const isNarrowScreen = useBreakpoint('lg');
  const isShortScreen = useVerticalBreakpoint('md');
  return !isNarrowScreen && !isShortScreen;
};
